module.exports = __webpack_public_path__ + "static/img/chabanegoki.a59caa4.jpg";